import Constants from '../constants/RelationshipTypesConstants';
import RelationshipTypesRemoting from '../../remoting/RelationshipTypesRemoting';
import StatusCodes from '../../model/StatusCodes';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getRelationshipTypes called on client getting relationship types
 * and filling relationship dropdown with them
 */
export function getRelationshipTypes (reservationId) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.RELATIONSHIP_TYPES_REQUEST));
    RelationshipTypesRemoting.getRelationshipTypes(reservationId)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          console.error('Error occured: ', response.message);
          return dispatch(dispatchToReducer(Constants.RELATIONSHIP_TYPES_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          return dispatch(dispatchToReducer(Constants.RELATIONSHIP_TYPES_SUCCESS, response.data));
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.RELATIONSHIP_TYPES_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/RelationshipTypesActions.js